import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { ItemsNavbar } from "../../../api/packbo/models/items-navbar";
import { ItemsProductCategories } from "../../../api/packbo/models/items-product-categories";

type NavigationState = {
    categories: ItemsProductCategories[];
    navbarDefinition: ItemsNavbar | null;
};

const initialState: NavigationState = {
    categories: [],
    navbarDefinition: null
};

export const NavigationStore = signalStore(
    withState(initialState),
    withMethods((store) => ({
        setCategories(categories: ItemsProductCategories[]) {
            patchState(store, { categories });
        },
        setNavbarDefinition(navbarDefinition: ItemsNavbar | null) {
            patchState(store, { navbarDefinition });
        }
    }))
);
